export default __webpack_public_path__ + "static/fingerprint-bg-mobile-0cfc3fc1375e50e8f559a806a7bcdd0d.svg";